"use client";

import { recordNearMeFunnelMetric } from "@/lib/nearMeMetricsClient";
import type { NearMeFunnelMetricAction } from "@/lib/push-notifications/near-me-notification-metrics";
import type { NotificationSetupBannerMode } from "@/lib/notifications/notification-setup-eligibility";

export async function recordNotificationSetupMetric(
  action: NearMeFunnelMetricAction,
  metadata?: Record<string, unknown>,
): Promise<void> {
  await recordNearMeFunnelMetric(action, metadata);
}

export type NotificationSetupMetricSource =
  | "setup_banner"
  | "setup_sheet"
  | "profile"
  | "market"
  | "sell_success"
  | "pwa_post_install"
  | "onboarding";

export function recordNotificationSetupBannerShown(
  mode: NotificationSetupBannerMode,
  source: NotificationSetupMetricSource = "setup_banner",
): void {
  void recordNotificationSetupMetric("notification_setup_banner_shown", {
    source,
    mode,
  });
}

export function recordNotificationSetupBannerDismissed(
  mode: NotificationSetupBannerMode,
  dismissCount: number,
): void {
  void recordNotificationSetupMetric("notification_setup_banner_dismissed", {
    source: "setup_banner",
    mode,
    dismiss_count: dismissCount,
  });
}

export function recordNotificationSetupBannerCtaClick(
  mode: NotificationSetupBannerMode,
  target: "sheet" | "profile",
): void {
  void recordNotificationSetupMetric("notification_setup_banner_cta_click", {
    source: "setup_banner",
    mode,
    target,
  });
}

export function recordNotificationSetupSheetCompleted(resolved: {
  near_me: boolean;
  push: boolean;
}): void {
  void recordNotificationSetupMetric("notification_setup_sheet_completed", {
    source: "setup_banner",
    resolved_near_me: resolved.near_me,
    resolved_push: resolved.push,
  });
}

export function recordNotificationSetupGapResolved(
  gap: "near_me" | "push",
): void {
  void recordNotificationSetupMetric("notification_setup_gap_resolved", {
    source: "setup_banner",
    gap,
  });
}
